import { combineReducers } from '@reduxjs/toolkit';

import { apartmentStatusSlice } from './apartmentStatusSlice';
import { defectsSlice } from './defectsSlice';
import { furnitureSlice } from './furnitureSlice';
import { mediaSlice } from './mediaSlice';
import { structurePilotsSlice } from './structurePilots';

import { notificationSlice } from 'features/ApartmentStatus/RemainderNotification/slices';

export const apartmentsStatus = combineReducers({
  apartmentStatus: apartmentStatusSlice.reducer,
  defects: defectsSlice.reducer,
  remainderNotification: notificationSlice.reducer,
  furniture: furnitureSlice.reducer,
  media: mediaSlice.reducer,
  structurePilots: structurePilotsSlice.reducer,
});
